import React from 'react'
import { IconAlert, IconWarning, ModalClosed, ModalSuccess } from '~misc/icons';
import { Link } from "react-router-dom";
import "./index.scss";
import useHeader from '~components/Header/hooks/useHeader';


const ModalResponseRota = ({ isOpen, onClose, finalizar, iniciar,  title }) => {
    const modalClasses = isOpen ? 'fixed inset-0 bg-black bg-opacity-50 z-[99999]' : 'hidden';
    const overlayClasses = isOpen ? 'fixed inset-0 bg-black opacity-50 z-40' : 'hidden';
    return (
      <div className={modalClasses}>
      <div className="fixed inset-0 flex items-center justify-center z-50">
        <div className="bg-white px-14 py-14 rounded-[20px] shadow-lg z-50 text-center relative">
          <div className="flex justify-end">
            <button type='button' onClick={onClose} className="text-gray-500 p-4 rounded-tr-[20px] hover:text-gray-700 bg-quinaria absolute top-0 right-0">
              <ModalClosed />
            </button>
          </div>
          <IconAlert />
          <h3 className='font-bold text-2xl max-w-[600px] mx-auto mb-2'>Aviso!</h3>
          <h3 className='font-bold text-[19px] max-w-[600px] mx-auto'>{title}</h3>
          <div className="flex justify-center gap-3 mt-8">
              <button type='button' className='px-6 py-3 rounded  text-primaria font-bold  hover:bg-white hover:text-[#9ACA3C] border-2 border-[#9ACA3C] border-quartenaria transition duration-300 ease-in-out' onClick={iniciar} >
            Não, iniciar  nova visita
            </button>
            <button type='button' className='px-6 py-3 rounded bg-[#9ACA3C] text-white font-bold  hover:bg-white hover:text-[#9ACA3C] border-2 border-[#9ACA3C] border-quartenaria transition duration-300 ease-in-out' onClick={finalizar} >
              Finalizar visita em andamento
            </button>
          </div>
        </div>
        <div className={overlayClasses} onClick={onClose}></div>
      </div>
    </div>
    )
}

export default ModalResponseRota
